// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"8b90f226","70":"21a9e41e","319":"3881dcb3"}[chunkId] + ".chunk.js";
};